// src/components/ui/Loading.tsx

import React from "react";
import { Leaf } from "lucide-react";

interface LoadingProps {
  fullScreen?: boolean;
  text?: string;
}

const Loading: React.FC<LoadingProps> = ({ 
  fullScreen = true, 
  text = "Chargement..." 
}) => {
  const content = (
    <div className="flex flex-col items-center justify-center gap-5 text-center">
      {/* Cercle animé avec dégradé vert/jaune */}
      <div className="relative h-16 w-16">
        {/* Anneau tournant - dégradé personnalisé */}
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-secondary border-b-accent animate-spin"></div>
        
        {/* Deuxième anneau plus lent */}
        <div className="absolute inset-0 rounded-full border-4 border-dashed border-accent/30 animate-[spin_3s_linear_infinite]"></div>
        
        {/* Logo central */}
        <div className="absolute inset-0 flex items-center justify-center  ">
          <img
            src="/assets/logo/logoPsaumesetplantes-removebg-preview.png"
            alt="Psaumes et Plantes"
            className="h-10 w-10 object-contain rounded-full bg-white p-1 shadow-lg"
          />
        </div>
      </div>

      {/* Texte avec animation de pulsation */}
      <div className="space-y-1">
        <p className="text-sm font-medium text-secondary dark:text-accent animate-pulse">
          {text}
        </p>
        <p className="text-[11px] text-gray-400 italic">
          L'efficacité des Psaumes et Plantes
        </p>
      </div>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black/80 backdrop-blur-md z-50">
        {content}
      </div>
    );
  }

  return <div className="py-12">{content}</div>;
};

export default Loading;